import { useRouter } from 'next/router';
import { format } from 'date-fns';

import { Box, Text } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../hooks/queries/properties';

const ListingStats = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const {
    active,
    lastActivatedMs,
    expirationMs,
    isMultifamily,
    performance: { totalProspectCount = 0, viewCount = 0, isStartDateStartOfTheMonth = false } = {},
  } = listingDetails ?? {};

  if (!active && !expirationMs) {
    return null;
  }

  const dateTimestamp = Number(!active ? expirationMs : lastActivatedMs);
  const formattedDate = isNaN(dateTimestamp) ? '-' : format(new Date(dateTimestamp), 'MMM dd yyyy');

  const renderListingStat = (title: string, content: string) => {
    return (
      <Box css={{ flex: '1', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Text textStyle="body-sm" data-testid="ListingStat-Title" asChild>
          <p>{title}</p>
        </Text>

        <Text textStyle="body-bold" data-testid="ListingStat-Content" asChild>
          <p>{content}</p>
        </Text>
      </Box>
    );
  };

  return (
    <Box
      data-testid="ListingStats"
      css={{
        display: 'flex',
        flexDirection: 'row',
        padding: '{spacing.600} 0',
        marginBottom: '200',
      }}
    >
      {!isMultifamily && renderListingStat(active ? 'Published' : 'Deactivated', formattedDate)}

      {renderListingStat(
        `${'Total listing prospects'}${isStartDateStartOfTheMonth ? ' this month' : ''}`,
        totalProspectCount > 0 ? String(totalProspectCount) : '-',
      )}

      {renderListingStat(
        `Views${isStartDateStartOfTheMonth ? ' this month' : ''}`,
        viewCount > 0 ? String(viewCount) : '-',
      )}
    </Box>
  );
};

export default ListingStats;
